/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/* eslint-disable no-param-reassign */
import { types } from 'mobx-state-tree';
import { getMetaMasterData } from '../services/lobMeta';

const MetaModel = types.model('MetaModel', {
  id: types.maybeNull(types.string),
  label: types.maybeNull(types.string)
});

export default types
  .model('LobMetaMaster', {
    metalink: types.array(MetaModel),
    metadata: types.array(MetaModel)
  })
  .actions(self => ({
    setLobMetaMaster(data) {
      self.metalink = data.metalink;
      self.metadata = data.metadata;
    },
    async getLobMetaMaster() {
      const data = await getMetaMasterData();
      self.setLobMetaMaster(data);
    }
  }));
